<template>
    <a-card>
      
    <div style="margin-bottom:100px">
        <h3 style="text-align: center;margin:20px 0 40px">项目基本信息<span v-if="oneClassification">(<dict-render :dict-obj="dictObjs['projectTypeManage1']" :text="oneClassification"></dict-render>)</span></h3>
        <a-form layout="horizontal" :label-col="labelCol" :wrapper-col="wrapperCol"  ref="ruleForm" labelAlign="right" :model="form" :rules="rules">
            <!--可编辑区域 start-->
            <div  class="hidden">
                <!-- <div > -->
                <a-form-item label="主键ID" name="id">
                    <a-input v-model:value="form.id" placeholder="请输入主键ID" />
                </a-form-item>
                <a-form-item label="流程ID" name="processId">
                    <a-input v-model:value="form.processId" placeholder="请输入流程ID" />
                </a-form-item>
            </div>

            <a-row :gutter="20">
                <a-col :span="24">
                    <a-col style="
                    padding-left: 0px;
                    padding-right: 10px;" :span="12">
                    <a-form-item label="项目名称" name="projectName">
                        <a-input v-model:value="form.projectName" placeholder="请输入项目名称" />
                    </a-form-item>
                    </a-col>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="所属年度" name="year">
                        <year-picker v-model:value="form.year" disabled/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="一级分类" name="oneClassification">
                        <DictSelect v-model:value="form.oneClassification" :dict-name="'projectTypeManage1'" style="margin: -5px 0"
                          placeholder="请选择" disabled/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="二级分类" name="twoClassification">
                        <DictSelect v-model:value="form.twoClassification" :dict-name="'projectTypeManage2'" style="margin: -5px 0"
                          placeholder="请选择" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="申报日期" name="declareTime">
                        <date-picker v-model:value="form.declareTime" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="项目开始日期" name="startTime">
                        <date-picker v-model:value="form.startTime" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="项目结束日期" name="endTime">
                        <date-picker v-model:value="form.endTime" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="所属领域" name="domain">
                        <DictSelect v-model:value="form.domain" :dict-name="'corpbelong_type'" style="margin: -5px 0"
                          placeholder="请选择" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="项目类别" name="projectCategory">
                        <DictSelect v-model:value="form.projectCategory" :dict-name="'techno_projectCategory'" style="margin: -5px 0"
                          placeholder="请选择" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="技术领域" name="technicalField">
                        <DictSelect v-model:value="form.technicalField" :dict-name="'technical_field'" style="margin: -5px 0"
                          placeholder="请选择" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="创新模式" name="innovationMode">
                        <a-input v-model:value="form.innovationMode" placeholder="请输入创新模式" />
                    </a-form-item>
                </a-col>
                <!-- <a-col :span="12">
                    <a-form-item label="流程id" name="processId">
                        <a-input v-model:value="form.processId" placeholder="请输入流程id" />
                    </a-form-item>
                </a-col> -->
            </a-row>
            <!--可编辑区域 end-->
        </a-form>
        <!-- 重点研发项目 -->
        <formResearch v-if="oneClassification==2" ref="formResearch" />
        <!-- 科技成果转化引导 -->
        <formChievement v-if="oneClassification==3" ref="formChievement" />
        <div style="text-align:center">
            <a-button type="primary" html-type="submit" @click="onSubmitAll">
                项目基本信息保存
            </a-button>
        </div>
    </div>
    </a-card>
</template>
<script>
import formResearch from "./components/formResearch";
import formChievement from "./components/formChievement";
import dataCheck from "@/utils/dataCheck";
import {formMixin,dictMixin} from "@/mixins";
import {projectBasicsInfo} from "@/api/TechnologieprojekteApply";
import DictSelect from "@/components/other/DictSelect";
// import YearPicker from "@/components/form/datePicker/YearPicker";
import {postAction,postJson} from "@/utils/http/service";
import {filterObj} from "@/utils/util";
import DictRender from "@/components/other/DictRender";


export default {
    name: "项目基本信息",
    components: {
        DictRender,DictSelect,formResearch,formChievement},

    mixins: [formMixin,dictMixin],
    data() {
        return {
            errorOut: 0,
            oneClassification: null,
            dictNames: 'projectTypeManage1',
            labelCol: { span: 8 },
            wrapperCol: { span: 14 },
            form: {
                id: null,
                processId: this.$route.query.type,
                projectName: null,
                year: this.$route.query.year,
                oneClassification: this.$route.query.oneClassification,
                twoClassification: null,
                declareTime: null,
                startTime: null,
                endTime: null,
                domain: null,
                projectCategory: null,
                technicalField: null,
                innovationMode: null,
            },
            rules: {
                id: [],
                projectName: [
                    dataCheck.required({}),
                ],
                year: [
                    dataCheck.required({}),
                ],
                oneClassification: [
                    dataCheck.required({}),
                ],
                twoClassification: [
                    dataCheck.required({}),
                ],
                declareTime: [
                    dataCheck.required({}),
                ],
                startTime: [
                    dataCheck.required({}),
                ],
                endTime: [
                    dataCheck.required({}),
                ],
                domain: [
                    dataCheck.required({}),
                ],
                projectCategory: [
                    dataCheck.required({}),
                ],
                technicalField: [
                    dataCheck.required({}),
                ],
                innovationMode: [
                    dataCheck.required({}),
                ],
                processId: [
                    dataCheck.required({}),
                ],
            },

            options: [],

        }
    },
    
    computed: {
            submitUrl() {
                return projectBasicsInfo.saveOrUpdate
            }
        },
    mounted() {
        window.errorSet = this.errorSet;
        if(this.$route.query.id){
            this.onEdit()
        }
        this.oneClassification=this.$route.query.oneClassification
    },
    methods: {
        onEdit() {
            this.getAction({
                url: projectBasicsInfo.detail,
                params: { id: this.$route.query.id }
            }).then(res => {
                this.form = res
                this.$parent.$parent.postData(res.oneClassification,res.id)
            })
        },
        errorSet(){
        
            this.$notification.error({
                                message: '请检查必填项，必填项目不能不填',
                            });
            ++this.errorOut
            console.log(this.errorOut)
        },
        onSubmitAll(){
            this.onSubmit()
        },
        /*提交表单操作*/
        onSubmit() {
            if(this.$route.query.id){
                this.form.id = this.$route.query.id
            }
            if (!this.submitUrl) {
                this.$notification.warning({
                    message: '提示',
                    description: '请设置表单操作url地址',
                });
            } else {
                this.$refs.ruleForm
                    .validate()
                    .then(() => {
                        this.confirmLoading = true;
                        let params = this.transformParams
                            ? this.transformParams(this.form)
                            : this.form;
                            let action;
                        /*后台请求*/
                        if(this.submitType == 'json'){
                            action = postJson({
                                url: this.submitUrl,
                                params: filterObj(this.getSubmitParams(params)),
                                method: this.postMethod,
                                returnMsg: true
                            })
                        }else{
                            action=  postAction({
                                url: this.submitUrl,
                                params: filterObj(this.getSubmitParams(params)),
                                method: this.postMethod,
                                returnMsg: true
                            })
                        }
                        action.then((res) => {
                            console.log(res.data)
                            this.$parent.$parent.postData(res.data.classification,res.data.projectId)
                            this.confirmLoading = false;
                            this.$notification.success({
                                message: '提示',
                                description: res.msg || '操作成功',
                            });
                            
                            setTimeout(() => {
                                if(this.oneClassification==2){
                                    this.$refs.formResearch.onSubmit(res.data.projectId)
                                }else if(this.oneClassification==3){
                                    this.$refs.formChievement.onSubmit(res.data.projectId)
                                }
                                
                            this.$router.push({query: {id: res.data.projectId,oneClassification: this.form.oneClassification}})
                            }, 500);
                            if (this.onSuccessFn) {
                                this.onSuccessFn(res);
                                
                            }
                            if (this.isModal) {
                                this.$emit('finish');
                                this.onClose();
                            }
                        }).catch(() => {
                            this.confirmLoading = false;
                        })
                    })
                    .catch(error => {
                        if(error.errorFields.length){
                            this.$parent.$parent.errorSet()
                            this.$notification.error({
                                message: '请检查必填项，必填项目不能不填',
                            });
                        }
                        window.console.log('error', error);
                    });
            }
        },
    },
}
</script>
<style scoped lang="less">
:deep(.ant-modal-body) {
    height:100vh!important;
    max-height: 100vh!important;
     }
</style>
